import React from 'react'
import { inject, observer } from 'mobx-react'
import { useToast, Box } from 'native-base'
import { toJS } from 'mobx'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import EditCredit from '../../components/EditCredit'
import _ from 'lodash'

function EditCreditScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { memberStore, creditStore, navigation, route } = props
    const { userId } = route.params
    const [isLoading, setIsLoading] = React.useState(true)
    const [isSuccessModalVisible, setIsSuccessModalVisible] = React.useState(false)
    const toast = useToast()

    React.useEffect(() => {
        const focus = navigation.addListener('focus', async () => {
            try {
                await memberStore.getMember(userId)
                await creditStore.getChain()

            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        })
        return focus
    }, [navigation])


    React.useEffect(() => {
        const blur = navigation.addListener('blur', async () => {
            try {
                setIsSuccessModalVisible(false)
            }
            catch (e) {
                console.log(e)
            }
        })
        return blur
    }, [navigation])


    const handleOnSubmitError = async (errors) => {
        const _errorMessages = []
        for (const errorCode of errors) {
            _errorMessages.push(t(errorCode.toString()))
        }
        return toast.show({
            placement: 'top',
            render: () => {
                return (
                    <Box bg="red.500" px={4} py={3} rounded="md" mb={5} _text={{color:'white'}}>
                        {_errorMessages.join('\r\n')}
                    </Box>
                )
            },
        })
    }

    const handleOnSubmitPress = async (values) => {
        const { billPrice, remark } = values
        try {
            await creditStore.createCredit(userId, billPrice, remark)
            setIsSuccessModalVisible(true)
        }
        catch (e) {
            console.log(e)
            handleOnSubmitError(e)
        }
    }

    const handleOnSuccessModalClose = () => {
        setIsSuccessModalVisible(false)
        return navigation.pop()
    }

    if (isLoading) {
        return <Loading />
    }

    return (
        <EditCredit
            t={t}
            member={toJS(memberStore.member)}
            chain={toJS(creditStore.chain)}
            onSubmitPress={(values) => handleOnSubmitPress(values)}
            isSuccessModalVisible={isSuccessModalVisible}
            onSuccessModalClose={() => handleOnSuccessModalClose()}
        />
    )
}

export default inject('memberStore', 'creditStore')(observer(EditCreditScreen))